import { apiUri } from '../appConfig';
import handleErrorRequest from './handleErrorRequest';

const scheduleDetail = (id) => (
	fetch(`${apiUri}/schedule/${id}`)
		.then((res) => handleErrorRequest(res))
);

export default scheduleDetail;



// WEBPACK FOOTER //
// ./src/js/request/scheduleDetail.js